module.exports = __webpack_public_path__ + "img/laptop.7d94b3c3.jpeg";